import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (state: IStore) => state.infoVoucher.isFetching;
const getIsFetchFailed = (state: IStore) => state.infoVoucher.isFetchFailed;
const getVoucherContent = (state: IStore) => state.infoVoucher.content;

const getVoucherPurchaseImageUrl = createSelector(
  [getVoucherContent],
  (content) => {
    return content ? content.purchaseImageUrl : null;
  },
);

export {
  getIsFetching,
  getIsFetchFailed,
  getVoucherContent,
  getVoucherPurchaseImageUrl,
};


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/Redux/selectors.tsx